<div class="video-player {{videoClass}}">
  <div [id]="vidalyticsEmbedId" class="" style="width: 100%; position:relative; padding-top: 56.25%;"></div>
</div>
